import { get, post, put } from '@/base/http-base'
//查询下级渠道商列表
export function getSubDistributorList(params) {
  return get('/localAPI/getSubDistributorList', params, {
    target: '.form-loading',
    isRemoveField: true,
  })
}

//导出客户列表
export function exportMyCustomerList(params) {
  return post('/localAPI/queryMyCustomerList', params, {
    isRemoveField: true,
  })
}

//导出渠道商
export function exportSubDistributorList(params) {
  return post('/localAPI/getSubDistributorList', params, {
    isRemoveField: true,
  })
}

//导出下级渠道商客户
export function exportSubCustomerList(params) {
  return post('/localAPI/querySubCustomerList', params, {
    isRemoveField: true,
  })
}

/**
 * 一级渠道商信息
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getFirstInfo(params) {
  return get('/localAPI/firstLevel/distributorInfo', params, {
    // target: '.mainCon'
    // isLoading: false
  })
}

/**
 * 邀请页面仅查询渠道商公开名称
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getDistributorPublicInfo(params) {
  return get('/localAPI/firstLevel/distributorPublicInfo', params)
}
/**
 * 修改一级渠道商信息
 *
 * @export
 * @param {*} params
 * @returns
 */
export function modifyFirstInfo(params) {
  return post('/localAPI/firstLevel/distributorInfo', params, {
    target: '.form-loading',
  })
}

//查询我的客户列表

export function queryMyCustomerList(params) {
  return get('/localAPI/queryMyCustomerList', params, {
    target: '.form-loading',
    isRemoveField: true,
  })
}

/**
 * 获得我的客户详情
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getFirstClientInfo(params) {
  return get('/localAPI/firstLevel/clientInfo', params, {
    target: '.mainCon',
    isOutMsg: false,
  })
}
/**
 * 修改我的用户详情
 *
 * @export
 * @param {*} params
 * @returns
 */
export function modifyFirstClientInfo(params, isLoading = true) {
  return post('/localAPI/firstLevel/clientInfo', params, {
    target: '.form-loading',
    isLoading
  })
}

export function addCustomer(params, query = {}) {
  return put('/localAPI/firstLevel/clientInfo', params, query)
}
/**
 * 校验二级渠道商的渠道商名称，京东云账号，营业执照号
 *
 * @export
 * @param {*} params
 * @returns
 */
export function secondDistributorCheck(params) {
  return get('/localAPI/secondLevel/validateDistributor', params, {
    target: '.second-distributor-loading',
    isLoading: false,
  })
}

/**
 * 校验账号是否为京东云账号
 *
 * @export
 * @param {*} params
 * @returns
 */
export function secondPinCheck(params) {
  return get('/localAPI/secondLevel/describeBaseInfo', params, {
    target: '.user-loading',
    isLoading: false,
  })
}

/**
 * 新增二级渠道商
 *
 * @export
 * @param {*} params
 * @returns
 */
export function addSecondInfo(params) {
  return post('/localAPI/secondLevel/addDistributorInfo', params, {
    target: '.mainCon',
  })
}

/**
 * 修改二级渠道商
 *
 * @export
 * @param {*} params
 * @returns
 */
export function modifySecondInfo(params) {
  return post('/localAPI/secondLevel/modifyDistributorInfo', params, {
    target: '.jc-page-content',
  })
}

/**
 * 获取二级渠道商详情
 *
 * @export
 * @param {*} params
 * @returns
 */
export function getSecondInfo(params) {
  return get('/localAPI/secondLevel/queryDistributorInfo', params, {
    target: '.mainCon',
  })
}
// 查询下级渠道商客户列表
export function querySubCustomerList(params) {
  return get('/localAPI/querySubCustomerList', params, {
    target: '.form-loading',
    isRemoveField: true,
  })
}

// 我的销售业绩
export function queryMyAchievment(params) {
  return get('/localAPI/achievmentManager/queryMyAchievment', params, {
    target: '.form-loading',
    isRemoveField: true,
  })
}

// 导出我的销售业绩
export function exportMyAchievment(params) {
  return get('/localAPI/achievmentManager/exportMyAchievment', params, {
    isRemoveField: true,
  })
}
// 我的渠道商销售业绩
export function querySubDistributorAchievment(params) {
  return get(
    '/localAPI/achievmentManager/querySubDistributorAchievment',
    params,
    {
      target: '.form-loading',
      isRemoveField: true,
    },
  )
}

// 导出我的渠道商销售业绩
export function exportSubDistributorAchievment(params) {
  return get(
    '/localAPI/achievmentManager/exportSubDistributorAchievment',
    params,
    {
      isRemoveField: true,
    },
  )
}

// 客户消费总览
export function queryMyCustomerAchievment(params) {
  return get('/localAPI/achievmentManager/queryMyCustomerAchievment', params, {
    target: '.form-loading',
    isRemoveField: true,
  })
}

// 导出客户消费总览
export function exportMyCustomerAchievment(params) {
  return get('/localAPI/achievmentManager/exportMyCustomerAchievment', params, {
    isRemoveField: true,
  })
}

// 客户预付费明细
export function queryCustPreFeeList(params) {
  return get('/localAPI/achievmentManager/queryCustPreFeeList', params, {
    target: '.form-loading',
    isRemoveField: true,
  })
}

// 导出客户预付费明细
export function exportCustPreFeeList(params) {
  return get('/localAPI/achievmentManager/exportCustPreFeeList', params, {
    isRemoveField: true,
  })
}

// 客户预付费详情
export function queryCustPreFeeDetail(params) {
  return get('/localAPI/achievmentManager/queryCustPreFeeDetail', params, {
    target: '.form-loading',
    isRemoveField: true,
  })
}

// 后付费明细
export function queryCustPostFeeList(params) {
  return get('/localAPI/achievmentManager/queryCustPostFeeList', params, {
    isRemoveField: true,
  })
}

// 导出客户后付费明细
export function exportCustPostFeeList(params) {
  return get('/localAPI/achievmentManager/exportCustPostFeeList', params, {
    isRemoveField: true,
  })
}

// 返佣单列表
export function queryMyReturnBillList(params) {
  return get('/localAPI/achievmentManager/queryMyReturnBillList', params, {
    target: '.form-loading',
    isRemoveField: true,
  })
}

// 导出返佣单列表
export function exportMyReturnBillList(params) {
  return get('/localAPI/achievmentManager/exportMyReturnBillList', params, {
    isRemoveField: true,
  })
}

// 返佣单详情
export function queryReturnBillDetail(params) {
  return get('/localAPI/achievmentManager/queryReturnBillDetail', params, {
    target: '.form-loading',
    isRemoveField: true,
  })
}

// 导出返佣单详情
export function exportReturnBillDetail(params) {
  return post(
    '/v1/regions/cn-north-1/returnBill:exportReturnBillDetail',
    params,
    {
      isRemoveField: true,
      responseType: 'arraybuffer', // 下载文档流的时候一定要写
    },
  )
}
// 审批返佣单
export function approveReturnBill(params) {
  return get('/localAPI/achievmentManager/approveReturnBill', params, {
    isRemoveField: true,
  })
}

// 解除客户关联
export function unbundlingCust(params) {
  return post('/localAPI/unbundlingCust', params, {
    isRemoveField: true,
  })
}

// 删除二级渠道商
export function deleteDistributorLevelTwo(params) {
  return get('/localAPI/secondLevel/deleteDistributorLevelTwo', params, {
    isRemoveField: true,
    isOutMsg: false,
  })
}

// 校验是否展示附加信息
export function displayExtraInfo(params) {
  return get('/localAPI/secondLevel/displayExtraInfo', params, {
    isOutMsg: false,
  })
}

// 校验erp
export function verifyErp(params) {
  return post('/localAPI/secondLevel/verifyErp', params, {
    isLoading: false,
    isOutMsg: false,
  })
}

// 关联客户校验
export function customerValidator(params) {
  return post('/localAPI/secondLevel/customerValidator', params, {
    isLoading: false,
    isOutMsg: false,
  })
}

// 无登录态下获取渠道商详情
export function describeDistributor(params) {
  return get(
    `/noLogin/v1/regions/cn-north-1/distributorManage/${params.distributorId}`,
    {},
    {
      isLoading: false,
      isOutMsg: false,
    },
  )
}

// 查询代付订单列表
export function getPartnerOrderList(params) {
  return get('/openApi/order/getPartnerOrderList', params, {
    isLoading: false,
    isOutMsg: false,
  })
}
// 查询代付订单详情
export function getPartnerOrderDetail(params) {
  return get('/openApi/order/queryOrder', params, {
    isLoading: false,
    isOutMsg: false,
  })
}

// 驳回代付
export function cancelAgentPay(params) {
  return get('/openApi/order/modifyAgentPay', params, {
    isLoading: false,
    isOutMsg: false,
  })
}
// 查询渠道商返佣明细
export function queryDistributorBillReturnList(params) {
  return post('/openApi/partner/queryDistributorBillReturnList', params)
}

// 查询渠道客户资源
export function getCustomerResource(params) {
  return post('/openApi/partner/describeResources', params, {
    isLoading: false,
    isRemoveField: true,
  })
}

// 导出资源列表
export function exportCustomerResource(params) {
  return get('/openApi/partner/exportResources', params, {
    isLoading: false,
    isRemoveField: true,
  })
}

// 资源到期提醒
export function resourceExpireRemind(params) {
  return get('/openApi/partner/resourceExpireRemind', params, {
    isLoading: false
  })
}

// 判断是否开启资源提醒
export function describeResourceExpireRemind(params) {
  return get('/openApi/partner/describeResourceExpireRemind', params, {
    isLoading: false
  })
}
